var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTomato(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 93,
    viewBox: "0 0 89 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.1729 45.3789C89.3479 70.6991 68.9323 92.0732 44.2573 92.0732C19.5823 92.0732 -2.3021 69.3837 0.19478 44.228C3.71978 8.87839 27.0729 6.57656 44.2573 6.57656C54.6854 6.57656 85.5292 -3.61727 88.1729 45.3789Z",
    fill: "#EF4D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2666 37.8159C22.3729 22.0319 37.9416 26.6355 42.0541 20.7165C42.0541 32.0613 49.3979 26.4711 53.0697 31.568C57.7697 38.1447 59.5322 49.8183 65.1135 52.1201C59.6791 39.1312 68.4916 39.6245 56.1541 22.1963C62.7635 26.7999 66.1416 22.1963 75.101 26.3067C67.3166 12.4957 55.126 16.4417 55.126 16.4417C55.126 16.4417 62.7635 8.5497 69.226 12.6601C62.4697 1.47978 42.9354 15.6196 42.9354 15.6196C42.9354 15.6196 34.8572 0.164448 17.526 16.4417C27.6604 11.838 38.8229 16.4417 38.8229 16.4417C38.8229 16.4417 20.4635 11.3448 13.2666 37.8159Z",
    fill: "#8CC63E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2666 37.8159C13.2666 37.8159 23.9885 15.6195 42.4947 17.5925C26.1916 9.20725 13.2666 26.9644 13.2666 37.8159Z",
    fill: "#64892F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.526 16.4417C17.526 16.4417 31.0385 5.09704 42.9353 16.4417C39.4103 2.63082 21.3447 9.04299 17.526 16.4417Z",
    fill: "#64892F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8728 17.9214C63.7916 27.1287 57.7697 37.6513 65.1135 52.4487C60.1197 40.1175 72.4572 17.9214 45.8728 17.9214Z",
    fill: "#64892F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8228 16.4418C38.8228 16.4418 42.9353 9.53623 44.4041 0.986543C44.551 -0.164377 48.9572 3.94881e-05 48.8103 1.15096C47.3416 12.1669 51.3072 18.2503 51.3072 18.2503C51.3072 18.2503 48.2228 19.4013 44.4041 19.4013C40.5854 19.5657 38.8228 16.4418 38.8228 16.4418Z",
    fill: "#64892F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6072 1.97235C47.8239 1.97235 48.8103 1.53083 48.8103 0.986176C48.8103 0.441526 47.8239 0 46.6072 0C45.3904 0 44.4041 0.441526 44.4041 0.986176C44.4041 1.53083 45.3904 1.97235 46.6072 1.97235Z",
    fill: "#8CC63E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomato);
export default __webpack_public_path__ + "static/media/tomato.34a082a100c03421084a319c043739d0.svg";
export { ForwardRef as ReactComponent };